import { useState, useCallback } from 'react';

const useSnackbar = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');

  const showSnackbar = useCallback((msg, sev = 'success') => {
    setMessage(msg);
    setSeverity(sev);
    setOpen(true);
  }, []);

  const handleClose = useCallback((event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  }, []);

  const snackbarProps = {
    open,
    message,
    severity,
    onClose: handleClose,
  };

  return {
    open,
    message,
    severity,
    showSnackbar,
    handleClose,
    setOpen,
    setMessage,
    setSeverity,
    snackbarProps,
  };
};

export default useSnackbar;
